import React from 'react';
import * as Sentry from '@sentry/react';
import { Button } from '../ui/button';

export function SentryTestButton() {
  const triggerError = () => {
    throw new Error("Sentry Test Error - This is intentional for testing");
  };

  const triggerPerformanceTrace = () => {
    Sentry.startSpan({ op: "test", name: "Manual Test Span" }, () => {
      setTimeout(() => {
        console.log("Performance trace test completed");
      }, 100);
    });
  };

  const triggerCustomMessage = () => {
    Sentry.logger.error("Custom test message from Voxi frontend", { level: "info" });
  };

  if (import.meta.env.PROD) {
    return null; // Don't show in production
  }

  return (
    <div className="flex gap-2 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
      <div className="flex flex-col gap-2">
        <p className="text-sm text-yellow-800 font-medium">Sentry Testing (Dev Only)</p>
        <div className="flex gap-2">
          <Button onClick={triggerError} variant="destructive" size="sm">
            Trigger Error
          </Button>
          <Button onClick={triggerPerformanceTrace} variant="outline" size="sm">
            Test Performance
          </Button>
          <Button onClick={triggerCustomMessage} variant="outline" size="sm">
            Send Message
          </Button>
        </div>
      </div>
    </div>
  );
}